import { AutomationSchedule } from "../../../../domain/proposals/settings/proposalSettings"
import { addNewReminder, removeReminder, setEmailTemplateGuid, setEnabled, toViewSchedule, updateAfterDays, updateAtTime, ViewSchedule } from "./followUpScheduleModel"

export type ActionType =
  | 'AFTER_DAYS_CHANGED'
  | 'AT_TIME_CHANGED'
  | 'REMINDER_ADDED'
  | 'REMINDER_REMOVED'
  | 'EMAIL_TEMPLATE_CHANGED'
  | 'DEFAULT_SCHEDULE_CHANGED'
  | 'ENABLED_CHANGED'

type FollowUpScheduleState = {
  schedule: AutomationSchedule
  viewSchedule: ViewSchedule
}

export type Action =
  | { type: 'AFTER_DAYS_CHANGED', id: string, value: number }
  | { type: 'AT_TIME_CHANGED', id: string, value: string }
  | { type: 'REMINDER_ADDED' }
  | { type: 'REMINDER_REMOVED', id: string }
  | { type: 'EMAIL_TEMPLATE_CHANGED', id: string, value: string }
  | { type: 'DEFAULT_SCHEDULE_CHANGED', value: AutomationSchedule }
  | { type: 'ENABLED_CHANGED', value: boolean }

const updateViewSchedule = (schedule: AutomationSchedule): FollowUpScheduleState => {
  return { schedule, viewSchedule: toViewSchedule(schedule) }
}

export const reducer = (state: FollowUpScheduleState, action: Action): FollowUpScheduleState => {
  switch (action.type) {
    case 'AFTER_DAYS_CHANGED':
      return updateViewSchedule(updateAfterDays(state.schedule, action.id, action.value))
    case 'AT_TIME_CHANGED':
      return updateViewSchedule(updateAtTime(state.schedule, action.id, action.value))
    case 'REMINDER_ADDED':
      return updateViewSchedule(addNewReminder(state.schedule))
    case 'REMINDER_REMOVED':
      return updateViewSchedule(removeReminder(state.schedule, action.id))
    case 'EMAIL_TEMPLATE_CHANGED':
      return updateViewSchedule(setEmailTemplateGuid(state.schedule, action.id, action.value))
    case 'DEFAULT_SCHEDULE_CHANGED':
      return updateViewSchedule(action.value)
    case 'ENABLED_CHANGED':
      return updateViewSchedule(setEnabled(state.schedule, action.value))
    default:
      return state
  }
}
